import { NgClass } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Button, Badge, HelpButton, DetectBrowserDirective } from 'excellence-ui';
import { SupplierContractCheckItemResponse } from '../../../../core/clients/omni-core/models';
import { getFileUrl } from '../../../organizations/pipes/organization-file-url-pipe';
import { environment } from '../../../../../environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-supplier-contract-check-item',
  imports: [NgClass, NgIcon, Button, Badge, HelpButton, TranslocoPipe, DetectBrowserDirective],
  templateUrl: './supplier-contract-check-item.html',
  styleUrl: './supplier-contract-check-item.css',
})
export class SupplierContractCheckItem {
  data = input.required<SupplierContractCheckItemResponse>();
  organizationId = input.required<string>();

  protected showReport = signal(false);

  protected readonly generalReasonsLink = environment.articles.contractCheck.generalReasonsLink;

  protected onClickDownload(documentId: string) {
    window.open(getFileUrl(documentId, this.organizationId()), '_blank');
  }
}
